import React, { useEffect, useState } from 'react';
import {
    Container,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    Button,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import {
    Typography,
    TablePagination,
} from "@mui/material";
import { getInsiderAssessmentsService } from "../../../services/assessments.service";
import { useHistory } from 'react-router-dom';
import LoaderWithBackDrop from "../../../components/LoaderWithBackDrop/LoaderWithBackDrop.comp";

const useStyles = makeStyles((theme) => ({
    container: {
        marginTop: theme.spacing(1),
        width: '100%',
        px: { xs: 0, sm: 2 },
        [theme.breakpoints.between('sm', 'md')]: {
            marginTop: '75px',
        },
    },
    tableRoot: {
        width: '100%',
        tableLayout: 'fixed',
        borderCollapse: 'separate',
        borderSpacing: '0px',
    },
    tableHeaderCell: {
        fontSize: '17px',
        fontWeight: 500,
        textAlign: 'center',
        [theme.breakpoints.down('sm')]: {
            fontSize: '12px',
        },
    },
    tableCell: {
        color: '#ED6628',
        textAlign: 'center',
        fontSize: '17px',
        padding: '16px',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        maxWidth: 0,
        [theme.breakpoints.down('sm')]: {
            wordBreak:'break-word',
            fontSize: '11px',
            padding: '12px !important',
        },
    },
    tableCellLeft: {
        color: '#ED6628',
        textAlign: 'left',
        fontSize: '17px',
        padding: '16px',
        wordBreak: 'break-word',
        overflowWrap: 'break-word',
        maxWidth: 0,
        [theme.breakpoints.down('sm')]: {
            fontSize: '11px',
            padding: '12px !important',
        },
    },
    buttonCell: {
        textAlign: 'center',
        [theme.breakpoints.down('sm')]: {
            padding: '0 !important',
        },
    },
    title: {
        background: 'linear-gradient(to right, #6A8EC9 10%, #8C74A7 35%, #D44C71 59%, #C91C6E 100%)',
        color: 'transparent',
        backgroundClip: 'text',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        fontWeight: '500 !important',
        textAlign: 'center',
        fontSize: '45px !important',
        [theme.breakpoints.down('sm')]: {
            fontSize: "32px !important",
        },
    },
    viewButton: {
        backgroundColor: "#ff6468",
        color: "#fff",
        fontWeight: 'bold',
        fontSize: '16px',
        borderRadius: '20px',
        boxShadow: 'none',
        padding:'10px 20px',
        textTransform: "none",
        '&:hover': {
            backgroundColor: "#ff6468",
            color: "#fff",
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: '10px',
            padding: '8px 0px',
            borderRadius: '8px',
            width: '100%',
            display: 'block',
            minWidth: 'unset',
        },
    }
}));

const DQProAssessmentList = () => {
    const classes = useStyles();
    const history = useHistory();
    const [assessments, setAssessments] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        getInsiderAssessmentsService().then(response => {
            const assessments = response?.data?.assessments || [];
            assessments.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
            setAssessments(assessments);
            setLoading(false);
        }).catch(() => {
            setAssessments([]);
            setLoading(false);
        });
    }, []);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleViewAssessment = (assessment) => {
        history.push(`/dq_pro/product/view/${assessment.code}`, { assessment });
    };

    return (
        <Container className={classes.container} maxWidth={false}>
            <Typography variant="h2" className={classes.title} sx={{ mb: 2 }}>
                Your Assessments
            </Typography>
            <Typography variant="h5" sx={{ fontSize: { xs: '18px', sm: '1.5rem' }, textAlign: 'center', p: { xs: '0 20px', sm: '0 30px', lg: '0 170px' }, mx: 'auto', mb: 4 }}>
                The following is a list of your created assessments.
            </Typography>
            <TableContainer component={Paper} sx={{ backgroundColor: '#fff', width:'100%', maxWidth: '100vw', overflowX: 'auto', }}>
                <Table className={classes.tableRoot} aria-label="assessments table">
                    <TableHead>
                        <TableRow>
                            <TableCell className={classes.tableHeaderCell} style={{textAlign: 'left'}}>Assessment ID</TableCell>
                            <TableCell className={classes.tableHeaderCell} style={{textAlign: 'left'}}>Assessment Name</TableCell>
                            <TableCell className={classes.tableHeaderCell} style={{textAlign: 'left'}}># of Questions</TableCell>
                            <TableCell className={classes.tableHeaderCell} style={{textAlign: 'left'}}>Time (min)</TableCell>
                            <TableCell className={classes.tableHeaderCell} style={{textAlign: 'left'}}></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {assessments.length > 0 ? (
                            assessments
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((assessment) => (
                                    <TableRow key={assessment.code}>
                                        <TableCell className={classes.tableCellLeft}>{assessment.code}</TableCell>
                                        <TableCell className={classes.tableCellLeft}>{assessment.full_name}</TableCell>
                                        <TableCell className={classes.tableCell}>{assessment.length_questions}</TableCell>
                                        <TableCell className={classes.tableCell}>{assessment.time_to_complete_minutes}</TableCell>
                                        <TableCell className={`${classes.tableCell} ${classes.buttonCell}`}>
                                            <Button
                                                className={classes.viewButton}
                                                onClick={() => handleViewAssessment(assessment)}
                                            >
                                                View Assessment
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                ))
                        ) : (
                            <TableRow>
                                <TableCell colSpan={5} align="center">
                                    No assessments found.
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    component="div"
                    count={assessments.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </TableContainer>
            <LoaderWithBackDrop loading={loading} />
        </Container>
    );
};

export default DQProAssessmentList;
